import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class AuthService {

    static login(item) {
        return axiosInstance.post(API_BASE_URL + API_PATHS.adminlogin, item)
            .then((response) => {
                if (response?.data && response?.data?.status === true) {
                    localStorage.setItem("user", JSON.stringify(response.data));
                    localStorage.setItem("accessToken", response.data.data.accessToken);
                    localStorage.setItem("refreshToken", response.data.data.refreshToken);
                    return response.data;
                } else {
                    // If the login attempt was unsuccessful, throw an error
                    throw new Error(response?.data?.message || 'Invalid credintials');
                }
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }




    static userLogin(item) {
        return axiosInstance.post(API_BASE_URL + API_PATHS.userlogin, item)
            .then((response) => {
                if (response?.data && response?.data?.success === true) {
                    return response.data;
                } else {
                    throw new Error(response?.data?.message || "Invalid credentials")

                }
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }


    // login verify Otp
    static userloginVerifyOtp(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.userLoginOtpVerify}`;

        return axiosInstance
            .post(api, item)
            .then((response) => {
                if (response?.data && response?.data?.success === true) {
                    const userData = {
                        ...response.data.user,
                        role: "user"
                    };

                    localStorage.setItem("user", JSON.stringify(userData));
                    localStorage.setItem("accessToken", response.data.accessToken);
                    localStorage.setItem("refreshToken", response.data.refreshToken);
                    return response.data;
                } else {
                    throw new Error(response?.data?.message || "OTP verification failed");
                }
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }



    static sendotp(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.sendotp}`;
        return axiosInstance
            .post(api, item)
    }


    static sendemailotp(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.sendemailotp}`;
        return axiosInstance
            .post(api, item)
    }


    static createVerification(item) {
        const api = `${API_BASE_URL}${API_PATHS.createVerification}`;

        return axiosInstance
            .post(api, item)
            .then((response) => response.data);
    }

    static verifyotp(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.verfyotp}`;
        return axiosInstance
            .post(api, item)
    }



    static verifyemailotp(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.verifyemailotp}`;
        return axiosInstance
            .post(api, item)
    }


    static userVerifyOtp(item) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.userOtpverify}`;
        return axiosInstance
            .post(api, item)
            .then((response) => {
                if (response?.data && response?.data?.success === true) {
                    localStorage.setItem("user", JSON.stringify(response.data.user));
                    localStorage.setItem("accessToken", response.data.accessToken);
                    localStorage.setItem("refreshToken", response.data.refreshToken);
                    return response.data;
                } else {
                    throw new Error(response?.data?.message || "OTP verification failed");
                }
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    }



    static getAminity() {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.getAmenity}`;

        return axiosInstance.get(api)
    }



    static getRoles() {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.getRoles}`;

        return axiosInstance
            .get(api)

    }


    static getStats(item) {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.orggetStats}?range=${item.range}&orgId=${item.orgId}`;

        return axiosInstance
            .get(api)

    }


    static getCounts(item) {

        let api = '';

        api = `${API_BASE_URL}${API_PATHS.orggetDashCount}?range=${item.range}&orgId=${item.orgId}`;

        return axiosInstance
            .get(api)

    }




    // Method to remove user details from localStorage
    static removeUserDetails() {
        localStorage.removeItem('user');
    }

    // Method to get user details from localStorage
    static getUserDetails() {
        const user = localStorage.getItem('user');
        try {
            return user ? JSON.parse(user) : "";
        } catch (e) {
            console.error('Error parsing user details from localStorage', e);
            return null;
        }
    }

    // Method to set tokens in localStorage
    static setTokens(data) {
        localStorage.setItem("accessToken", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken)
    }
}

export default AuthService;
